import Promoters from ".";
import PromoterCommission from "../../../../components/sections/front/promoter/PromoterComission";
import PromoterDashboard from "../../../../components/sections/front/promoter/PromoterDashboard";
import PromoterSales from "../../../../components/sections/front/promoter/PromoterSales";
import PromoterSettlement from "../../../../components/sections/front/promoter/PromoterSattlement";
import Earnings from "./Earnings";
import PromotionEvents from "./PromotionEvents";

export const promotersUserRoutes = (data) => {
  const user_role_in_org = data?.selectedOrganization?.verificationData?.role; //promoter||"admin"||"staff"
  const global_routes = [
    {
      path: "/:lang/promotion-events",
      title: "promoters",
      layout: "front",
      routeType: ["user", "organization"].includes(data?.user?.role)
        ? data?.user?.role
        : "user",
      component: PromotionEvents,
    },
    {
      path: "/:lang/promotion-events-dashboard/:promoterId",
      title: "promoters_dashboard",
      layout: "promoter",
      routeType: ["user", "organization"].includes(data?.user?.role)
        ? data?.user?.role
        : "user",
      component: PromoterDashboard,
    },
    {
      path: "/:lang/promotion-events-sales/:promoterId",
      title: "promoters_sales",
      layout: "promoter",
      routeType: ["user", "organization"].includes(data?.user?.role)
        ? data?.user?.role
        : "user",
      component: PromoterSales,
    },
    {
      path: "/:lang/promotion-events-settlement/:promoterId",
      title: "promoters_settlement",
      layout: "promoter",
      routeType: ["user", "organization"].includes(data?.user?.role)
        ? data?.user?.role
        : "user",
      component: PromoterSettlement,
    },
    {
      path: "/:lang/promotion-events-commission/:promoterId",
      title: "promoters_commission",
      layout: "promoter",
      routeType: ["user", "organization"].includes(data?.user?.role)
        ? data?.user?.role
        : "user",
      component: PromoterCommission,
    },
  ];
  if (user_role_in_org === "promoter") {
    return global_routes;
  }
  return [
    ...global_routes,
    {
      path: "/:lang/earnings",
      title: "Earnings",
      layout: "front",
      routeType: ["user", "organization"].includes(data?.user?.role)
        ? data?.user?.role
        : "user",
      component: Earnings,
    },
    {
      path: "/:lang/user/promoters/:eventId",
      title: "promoters",
      layout: "frontUserInner",
      routeType: "organization",
      component: Promoters,
    },
  ];
};
